@if (showInfoBlock$$()) {
  <div class="contentfooter info version">
    <div class="version" [matTooltip]="infoTooltip$$() ?? ''" matTooltipPosition="above">{{info$$()}}</div>
  </div>
}
<app-progress-bar />
<div class="footer-block">
  <div class="side-container left" [class.invisible]="hideSideBlockLeft$$()">
    <ng-container *ngTemplateOutlet="template_buttonLeft$$()" />
  </div>
  <div class="content-container horizontal-buttons" [style.visibility]="loadingPage$$() ? 'hidden' : 'visible'">
    <ng-container *ngTemplateOutlet="template_contentBlock$$()" />
  </div>
  <div class="side-container right" [class.invisible]="hideSideBlockRight$$()">
    <ng-container *ngTemplateOutlet="template_buttonRight$$() ?? buttonRight_default" />
  </div>
</div>

<ng-template #buttonRight_default>
  <app-button-navigation (btnClick)="toggleSidenav()" 
    [lockOnLoad]=true 
    [tooltip]="'menu'"
>
    <app-icon name="bars" />
  </app-button-navigation>
</ng-template>